import Privacy from '@/components/Privacy';
import Recommend from '@/components/Recommend';

//Navigation Bars
import Nav from '@/components/Nav';

//Heroes
import AboutPageHero from '@/components/AboutPageHero';
import Hero from '@/components/Hero';
import HeroFullBG from '@/components/HeroFullBG';
import HeroHalf from '@/components/HeroHalf';

//USPs
import USP from '@/components/USP';

//Credentials
import Credentials from '@/components/Credentials';
import CredentialsLine from '@/components/CredentialsLine';

//SatisfactionGuarantee
import SatisfactionGuarantee from '@/components/SatisfactionGuarantee';

//Financial
import Financial from '@/components/Financial';

//Reviews
import ReviewFloat from '@/components/ReviewFloat';
import ReviewHero from '@/components/ReviewHero';
import Reviews from '@/components/Reviews';
import ReviewSlider from '@/components/ReviewSlider';
import TrustBadge from '@/components/TrustBadge';

//Services
import SecondaryServices from '@/components/SecondaryServices';
import Service from '@/components/Service';
import Services from '@/components/Services';
import ServiceTabs from '@/components/ServiceTabs';

//Gallery
import Gallery from '@/components/Gallery';
import ImageGallery from '@/components/ImageGallery';
import ImageSlider from '@/components/ImageSlider';

//Grids
import ComparisonTable from '@/components/ComparisonTable';
import ItemCounter from '@/components/ItemCounter';
import ItemGrid from '@/components/ItemGrid';
import List from '@/components/List';
import Pricing from '@/components/Pricing';

//Processes
import Process from '@/components/Process';

//Map
import GoogleMap from '@/components/GoogleMap';

//CTAs
import CallToAction from '@/components/CallToAction';
import CTAHero from '@/components/CTAHero';

//Footers
import Footer from '@/components/Footer';

//Story
import ReviewPage from '@/components/ReviewPage';
import ReviewStories from '@/components/ReviewStories';
import WorkPage from '@/components/WorkPage';
import WorkStories from '@/components/WorkStories';

//Extra Pages
import AboutFeature from '@/components/AboutFeature';
import Faq from '@/components/Faq';
import FaqHero from '@/components/FaqHero';
import Team from '@/components/Team';
import TermsAndConditions from '@/components/TermsAndConditions';

//Custom Code
import CustomCode from '@/components/CustomCode';

//Blog

//Miscellaneous
import Basic from '@/components/Basic';
import FloatingAction from '@/components/FloatingAction';
import Popup from '@/components/Popup';
import ShapeDivider from '@/components/ShapeDivider';

export default {
    Privacy: Privacy,
    Recommend: Recommend,

    //Navigation Bars
    Nav: Nav,

    //Heroes
    Hero: Hero,
    HeroFullBG: HeroFullBG,
    HeroHalf: HeroHalf,
    AboutPageHero: AboutPageHero,

    //USPs
    USP: USP,

    //Credentials
    Credentials: Credentials,
    CredentialsLine: CredentialsLine,

    //Guarantee
    SatisfactionGuarantee: SatisfactionGuarantee,

    //Financial
    Financial: Financial,

    //Reviews
    Reviews: Reviews,
    ReviewHero: ReviewHero,
    ReviewFloat: ReviewFloat,
    ReviewSlider: ReviewSlider,
    TrustBadge: TrustBadge,

    //Services
    Service: Service,
    Services: Services,
    SecondaryServices: SecondaryServices,
    ServiceTabs: ServiceTabs,

    //Gallery
    Gallery: Gallery,
    ImageGallery: ImageGallery,
    ImageSlider: ImageSlider,

    //Grids
    ComparisonTable: ComparisonTable,
    ItemGrid: ItemGrid,
    Pricing: Pricing,
    ItemCounter: ItemCounter,
    List: List,

    //Processes
    Process: Process,

    //Maps
    GoogleMap: GoogleMap,

    //CTAs
    CallToAction: CallToAction,
    CTAHero: CTAHero,

    //Footers
    Footer: Footer,

    //Story
    ReviewPage: ReviewPage,
    ReviewStories: ReviewStories,
    WorkPage: WorkPage,
    WorkStories: WorkStories,

    //Extra Pages
    Faq: Faq,
    FaqHero: FaqHero,
    Team: Team,
    TermsAndConditions: TermsAndConditions,
    AboutFeature: AboutFeature,

    //Custom Code
    CustomCode: CustomCode,

    //Miscellaneous
    Basic: Basic,
    FloatingAction: FloatingAction,
    ShapeDivider: ShapeDivider,
    Popup: Popup,
};
